
<template>
    <v-app :dark="darktheme">

        <v-toolbar
                app
                :clipped-left="clipped"
        >

            <router-link :to="{name: 'home'}">
                <v-btn icon @click.stop="miniVariant = !miniVariant">
                    <v-icon>home</v-icon>
                </v-btn>
            </router-link>
            <v-toolbar-title v-text="title"></v-toolbar-title>

        </v-toolbar>
        <v-content>
            <v-container fill-height>
                <transition name="slide-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </v-container>
        </v-content>


        <v-footer :fixed="fixed" app>
            &nbsp&nbsp&nbsp
            <i class="far fa-moon" v-if="!darktheme" @click="darktheme = true"></i>
            <i class="fas fa-moon" v-else @click="darktheme = false"></i>

            <v-spacer></v-spacer>

            <span>&copy; 2018 Keinett &nbsp&nbsp&nbsp</span>
        </v-footer>
    </v-app>
</template>

<script>

    export default {
        name: 'App',
        data() {
            return {
                darktheme: false,
                clipped: false,
                drawer: true,
                fixed: false,
                items: [],
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'KeiCrypt'
            }
        }, beforeMount: function () {
            if (localStorage.getItem('darktheme') !== null) {
                var isDark = localStorage.getItem('darktheme');

                this.darktheme = (isDark === 'true');
            } else {
                localStorage.setItem('darktheme', this.darktheme);
            }
        },
        watch: {
            darktheme: function (after, before) {
                localStorage.setItem('darktheme', after);
            }
        }


    }
</script>
